import { DependenciesInjection } from "app/di/DependencyInjection";
import { IndividualUserImpl } from "../data/IndividualUserImpl";
import { IIndividualUserRepository } from "../domain/repositories/IIndividualUserRepository";
import { IndividualUserUseCase } from "../domain/useCases/IndividualUserUseCase";
import { IndividualUserToken } from "./IndividualUserToken";
import { IndividualUsersManagementViewModel } from "../presentation/viewModel/IndividualUsersManagementViewModel";

export class IndividualUserInjection {
  static initInjections() {
    DependenciesInjection.register<IIndividualUserRepository>(
      IndividualUserToken.IIndividualUserRepository,
      IndividualUserImpl,
      "otherRepo",
    );
    DependenciesInjection.register<IndividualUserUseCase>(
      IndividualUserToken.IndividualUserUseCase,
      IndividualUserUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<IndividualUsersManagementViewModel>(
      IndividualUserToken.IndividualUsersManagementViewModel,
      IndividualUsersManagementViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IIndividualUserRepository>(
      IndividualUserToken.IIndividualUserRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<IndividualUserUseCase>(
      IndividualUserToken.IndividualUserUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<IndividualUsersManagementViewModel>(
      IndividualUserToken.IndividualUsersManagementViewModel,
    );
  }
}
